import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.56 11.5a.6.6 0 0 1-.9 0L5.13 9.96c-.27-.24-.27-.65 0-.92a.64.64 0 0 1 .9 0l1.1 1.09 2.6-2.63a.64.64 0 0 1 .9 0c.27.28.27.69 0 .93zm6.4-6.27c.11.22.16.47.16.72v6.17c0 .99-.79 1.76-1.74 1.76H3.62c-.98 0-1.75-.77-1.75-1.76V5.96c0-.25.03-.5.14-.72L3.16 2.7c.27-.65.9-1.06 1.59-1.06h6.48c.68 0 1.3.4 1.58 1.06zm-5.3-.1h3.82l-.84-1.92a.48.48 0 0 0-.41-.27H8.66zm-5.47 7c0 .24.19.43.44.43h8.75c.21 0 .43-.19.43-.44V6.45H3.2v5.68Zm4.15-9.2h-2.6c-.16 0-.32.12-.4.28l-.85 1.92h3.85z"
    />
  </svg>
);

const ReleaseIcon = (props) => <Icon component={SVG} {...props} />;

export default ReleaseIcon;
